import { getInjector } from '../../utils/getInjector';
import { getTrackItem } from './utils';

/**
 * @param {object} payload
 * @param {object} payload.updatedItem - The item to be updated.
 * @param {object} payload.currentCartData - The cart data after update
 * @param {object} [payload.trackerOptions] - The options for tracking (optional)
 */
export const onTrackUpdateItem = async (payload) => {
  const { updatedItem, currentCartData, trackerOptions = {} } = payload;
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');
  const cartService = injector.get('cartService');

  const trackItem = getTrackItem(
    updatedItem.product_id,
    updatedItem.variation_id,
    updatedItem.type,
    currentCartData.items,
  );

  // shoplytics
  cartService.tracking(trackerService.userActionTypes.UPDATE_ITEM, trackItem, {
    scope: 'one_page_store',
    eventCategoryEmpty: true,
    ...trackerOptions,
  });
};
